import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from "react";
import * as Styled from "./CardGroup.styled";
export const CardContext = React.createContext({
    cardProps: {}
});
export const CardGroup = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { cardProps, children, display = "flex", hasPadding, hasBorder = true, isJoined, layout = "row", shadowDepth = "none", ...otherProps } = props;
    const contextValue = useMemo(() => ({
        cardProps
    }), [cardProps]);
    return (_jsx(Styled.CardGroup, { "data-testid": "CardGroup", ref: ref, display: display, hasBorder: hasBorder, hasPadding: hasPadding, isJoined: isJoined, layout: layout, shadowDepth: shadowDepth, ...otherProps, children: _jsx(CardContext.Provider, { value: contextValue, children: children }) }));
});
CardGroup.defaultProps = {
    hasBorder: false,
    layout: "row",
    width: "auto"
};
CardGroup.displayName = "CardGroup";
